var _defs, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.948,
    viewBox: "0 0 80.945 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "#e5243b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3,10.646h.024V23.14H14.07V6.818H11.879L9.352,9.779v2.864h.024Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.338,38.619A2.24,2.24,0,1,1,64.58,40.86a2.242,2.242,0,0,1-2.242-2.241",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,41.724A2.987,2.987,0,0,1,69.909,44.7v6.212a.868.868,0,0,1-1.737,0V45.577c0-.2-.058-.471-.424-.471-.253,0-.305.268-.315.439V61.536a1.249,1.249,0,0,1-2.5,0V52.321a.338.338,0,0,0-.354-.366h0a.344.344,0,0,0-.361.366v9.215a1.248,1.248,0,1,1-2.5,0V45.545c-.008-.171-.063-.439-.314-.439-.368,0-.423.271-.423.471v5.335a.868.868,0,0,1-1.737,0V44.7a2.987,2.987,0,0,1,2.715-2.976,1.321,1.321,0,0,1,.164-.014h4.9a1.407,1.407,0,0,1,.17.014",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.013,39.8a2.122,2.122,0,1,0-2.12,2.122,2.122,2.122,0,0,0,2.12-2.122",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.617,44.6l-1.764,5.742s-.314,1.053.579,1.316S42.59,50.9,42.59,50.9L44.013,46.1s.077-.369.354-.289.173.474.173.474L42.064,55.27h2.3V61.7a1.1,1.1,0,0,0,2.21,0V55.27h.628V61.7a1.106,1.106,0,0,0,2.212,0V55.27h2.3l-2.474-8.981s-.1-.4.172-.474.355.289.355.289L51.194,50.9s.271,1.028,1.158.765.579-1.316.579-1.316L51.167,44.6s-.63-1.66-2.026-1.66h-4.5c-1.4,0-2.027,1.66-2.027,1.66",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,39.8a2.122,2.122,0,1,0-2.121,2.122A2.123,2.123,0,0,0,36.3,39.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.906,44.6l-1.763,5.742s-.315,1.053.578,1.316,1.158-.765,1.158-.765L31.3,46.1s.077-.369.354-.289.173.474.173.474L29.354,55.27h2.3V61.7a1.106,1.106,0,0,0,2.211,0V55.27h.628V61.7a1.106,1.106,0,0,0,2.211,0V55.27h2.3l-2.473-8.981s-.106-.4.17-.474.356.289.356.289L38.483,50.9s.27,1.028,1.158.765.579-1.316.579-1.316L38.456,44.6s-.629-1.66-2.026-1.66h-4.5c-1.4,0-2.028,1.66-2.028,1.66",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.139,51.672A1.767,1.767,0,1,0,54.373,49.9a1.764,1.764,0,0,0,1.766,1.768",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,57.16a.614.614,0,0,0,.257.836.589.589,0,0,0,.757-.247l.961-3.062s.166-.205.166.007V61.9h.005a.906.906,0,0,0,1.812,0V59.058s-.053-.4.271-.4.275.4.275.4V61.9a.908.908,0,0,0,1.816,0V54.694c0-.212.112-.061.112-.061l.752,2.1a5.044,5.044,0,0,0,.427.978.67.67,0,0,0,.876-.362.658.658,0,0,0-.072-.644l.007-.007c-.022-.068-1.125-2.773-1.255-3.153-.4-1.163-1.124-1.153-1.822-1.172s-1.116,0-1.116,0-.446-.018-1.368.009-1.21.5-2.226,3.113c-.145.376-.635,1.594-.641,1.667Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.352,38.619a2.24,2.24,0,1,0-2.243,2.241,2.242,2.242,0,0,0,2.243-2.241",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.493,41.724A2.987,2.987,0,0,0,9.78,44.7v6.212a.869.869,0,0,0,1.738,0V45.577c0-.2.058-.471.424-.471.253,0,.3.268.316.439V61.536a1.248,1.248,0,1,0,2.495,0V52.321a.341.341,0,0,1,.356-.366h0a.343.343,0,0,1,.36.366v9.215a1.248,1.248,0,1,0,2.5,0V45.545c.007-.171.064-.439.314-.439.368,0,.423.271.423.471v5.335a.869.869,0,0,0,1.738,0V44.7a2.987,2.987,0,0,0-2.715-2.976,1.338,1.338,0,0,0-.165-.014h-4.9a1.425,1.425,0,0,0-.171.014",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.552a.659.659,0,0,1-.089-.006.653.653,0,0,1-.56-.735L.693-.088a.653.653,0,0,1,.735-.56.653.653,0,0,1,.56.735L.648,9.986A.654.654,0,0,1,0,10.552Z",
    transform: "translate(8.873 52.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,50.747a.644.644,0,0,0-1.189.34,1.172,1.172,0,0,0,.063.283l1.781,3.222a1.14,1.14,0,0,1,.109.425v6.919h0a.87.87,0,1,0,1.739,0v-2.73s-.049-.387.263-.387.262.387.262.387v2.73a.872.872,0,0,0,1.744,0V55.017a1.157,1.157,0,0,1,.107-.425l1.646-2.975a2.883,2.883,0,0,0,.2-.53.644.644,0,0,0-1.189-.34l-.007,0c-.052.045-.876,1.513-1.148,1.785a.715.715,0,0,1-.546.258H23.2a.714.714,0,0,1-.546-.258c-.275-.272-1.1-1.74-1.149-1.785Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.274,51.672A1.767,1.767,0,1,0,22.509,49.9a1.765,1.765,0,0,0,1.765,1.768",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.277,54.152l2,1.456.949,3.493H21.33l.951-3.493Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.217,9.16v4.156H23.28V6.7h1.093l1.2,3.794V6.7H26.5v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.486,11.785V8.234c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.392,17.4V20h.41a.478.478,0,0,0,.546-.547V17.934c0-.361-.166-.537-.546-.537ZM23.28,16.49h1.649c1.122,0,1.532.556,1.532,1.483v1.4c0,.927-.41,1.492-1.532,1.492h-.537V23.1H23.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.388,21.573V18.022c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M27.134,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,16.49,33.339,23.1H32.13L30.872,16.49H32l.761,4.614h.01l.78-4.614Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.155,16.49h2.654V17.4H36.267V19.29h1.1v.9h-1.1V22.2h1.542V23.1H35.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.615,17.4v2.058h.371a.481.481,0,0,0,.546-.546v-.975c0-.361-.166-.537-.546-.537Zm0,2.673V23.1H38.5V16.49h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3H40.659Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.133,16.49h2.956V17.4h-.917V23.1H43.05V17.4h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,20.587V23.1H46.758V20.587l-1.239-4.1H46.68L47.353,19h.01l.673-2.507H49.1Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG01);
export default __webpack_public_path__ + "static/media/G01.b51bfb97595ffe0e21947ee44e4ff210.svg";
export { ForwardRef as ReactComponent };